import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../public/css/style.css';
import '../public/css/dashboard-main.css';
import '../public/css/header.css';
import '@fortawesome/fontawesome-free/css/all.min.css'
import '../public/css/toastr.css';
import 'jquery/src/jquery';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import '../public/js/script.js';
import '../public/js/scrollbar.js';
import firebase from "firebase/app";
import {fireBaseConfig} from "./_helpers/apiRoute";
import toastr from "../public/js/toastr";

Vue.config.productionTip = false
// Vue.prototype.$http = axios

const accessToken = localStorage.getItem('token')
const source = localStorage.getItem('source')

if (accessToken && source) {
    var url = store.getters.getDomain

    var data = {
        access_token: accessToken,
        source: source
    }

    $.ajax({
        type: 'POST',
        async: false,
        url: `${url}api/v2/auth/find-user`,
        data: data,
        success: function (res) {
            if (res.user_id == "" || res.user_id == null) {
                store.dispatch("setLoggedOut");
                window.location.replace("/");
            }
            store.dispatch('setUser', res);
            if (res['college_settings']) {
                store.dispatch('setPreferences', res['college_settings']);
            } else {
                var defaultPreferences = {"students_approve":false,"jobs_approve":false,"internships_approve":false,"show_jobs":false,"show_internships":false,"show_teachers":false,"auto_approve_companies_for_job_placement":false,"auto_approve_companies_for_internship_placement":false}
                store.dispatch('setPreferences', defaultPreferences);
            }
        },
        error: function (jqXHR, exception) {
            alert('Unstable Internet Connection, Please check your Internet Connection');
            location.reload();
        }
    })
    const firebaseConfig = fireBaseConfig();

// Initialize Firebase
    firebase.initializeApp(firebaseConfig);
} else {
    store.dispatch("setLoggedOut");
}


router.beforeEach((to, from, next) => {
    $('#h-page-load').attr('class', 'loadings');
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.getAuthState) {
            next();
            return
        }
        router.push({name: 'home'});
        $('#myModal').css({'display': 'block'})
    } else {
        next()
    }

    // const publicPages = ['/login'];w
    // const authRequired = !publicPages.includes(to.path);
    // const loggedIn = localStorage.getItem('token') && localStorage.getItem('source');
    //
    // if(authRequired && !loggedIn){
    //     router.push({name: 'home'});
    //     $('#myModal').css({'display': 'block'})
    // }
});
router.afterEach((to, from, next) => {
    setTimeout(function () {
        if (document.getElementById("h-page-load")) {
            document.getElementById("h-page-load").classList.add("hides");
        }
        if (store.getters.getUser['user_type'] == "Individual" && store.getters.getUser['user_other_detail'] == false) {
            var currentUrl = window.location.pathname;
            if (currentUrl && currentUrl != "/") {
                router.push({name: 'home'});
                return false;
            }
        }
        var header = document.getElementsByTagName('header')[0];
        if(to.path === '/detail' || to.path === '/profile' || to.path === '/webinar-detail'){
            header.classList.add('header-white');
        } else {
            if(header && header.classList.contains('header-white')){
                header.classList.remove('header-white');
            }
        }
    }, 2000);
//     next()
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');


